import { IMarketingCategory } from '@features/productPreview/typescript';
import { TDataLayer } from '@typescript/index';
import { getCurrencyByRegion, toISO4217CurrencyCode } from '@utils/formatPrice';
import { getRegion, getLanguage } from '@utils/misc';
import getPublicEnv from '@utils/getPublicEnv';
import { safeParsePrice } from '@utils/safePriceParser';
import { rememberGa4ItemCategory } from '@reaffiliates/ga4ItemCategoryMemory';
const GoogleTagManagerViewItem = (itemId: number, itemName: string, priceString: string, categories: Array<IMarketingCategory>, brand: string | undefined) => {
  const region = getRegion();
  const currency = toISO4217CurrencyCode(getCurrencyByRegion(region));
  const price = safeParsePrice(priceString, currency);
  const currentLanguage = getLanguage(getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE'));
  const categoryName = (category: IMarketingCategory | undefined): string => {
    const name = category?.[`name_${currentLanguage}`];
    return typeof name === 'string' ? name : '';
  };
  const item_collection = categoryName(categories[0]);
  const item_list_name = categories[1] ? categoryName(categories[1]) : item_collection;
  const item_category = categories[2] ? categoryName(categories[2]) : item_list_name;
  rememberGa4ItemCategory(itemId, item_category);
  if (price === 0 || isNaN(price) || !isFinite(price)) {
    console.warn(`GoogleTagManagerViewItem: Invalid price "${priceString}" for product ${itemId} (${itemName}). Skipping DataLayer event.`);
    return;
  }
  const tagManagerArgs: TDataLayer = {
    event: 'view_item',
    ecommerce: {
      currency,
      value: price,
      items: [{
        item_collection,
        item_brand: brand,
        item_list_name,
        item_category,
        item_id: itemId,
        item_name: itemName,
        price
      }]
    }
  };
  if (window && window.dataLayer) {
    window.dataLayer.push({
      ecommerce: null
    });
    window.dataLayer.push(tagManagerArgs);
  }
};
export default GoogleTagManagerViewItem;